import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { pushDrill, popDrill, clearDrill } from 'app/slice/executive.slice'
import type { ExecutiveState } from 'app/slice/executive.slice'
import type { DrillLevel } from 'api/executive/executive.types'

export function useDrillStack() {
  const dispatch = useDispatch()
  const stack = useSelector((s: { executive: ExecutiveState }) => s.executive.drillStack)
  const history = useHistory()
  const location = useLocation()

  // Sync stack → URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const drillParam = stack.map((l) => l.id).join(',')
    const current = searchParams.get('drill') ?? ''
    if (drillParam !== current) {
      if (drillParam) searchParams.set('drill', drillParam)
      else searchParams.delete('drill')
      const nextSearch = searchParams.toString()
      history.replace({
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: location.hash,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stack])

  const push = (level: DrillLevel) => dispatch(pushDrill(level))
  const pop = () => dispatch(popDrill())
  const clear = () => dispatch(clearDrill())

  return { stack, push, pop, clear }
}
